import apiClient from './apiClient';

const base = '/admin/salary/danlon-activations';
const jobPath = id => `${base}/${encodeURIComponent(id)}`;
const request = async operation => {
  try { return (await operation()).data.data; }
  catch (error) {
    const body = error.response?.data;
    const result = new Error(body?.error?.message || body?.message || error.message);
    result.code = body?.error?.code || body?.code;
    result.details = body?.error?.details || body?.details;
    throw result;
  }
};

const danlonActivationService = {
  list: (year, month, signal) => request(() => apiClient.get(base, { params: { year, month }, signal })),
  // The server determines every employee with positive payroll hours. Table
  // selection and filters must never narrow this operation's target set.
  start: (year, month, { requestId }) => request(() => apiClient.post(base, { requestId }, { params: { year, month }, timeout: 95000 })),
  get: (id, signal) => request(() => apiClient.get(jobPath(id), { signal })),
  continue: (id, confirmation = {}) => request(() => apiClient.post(`${jobPath(id)}/continue`, confirmation)),
  cancel: id => request(() => apiClient.post(`${jobPath(id)}/cancel`, {})),
  closeSession: id => request(() => apiClient.post(`/admin/salary/danlon-browser-sessions/${encodeURIComponent(id)}/end`, {})),
  frame: async (id, signal) => (await apiClient.get(`${jobPath(id)}/frame`, {
    responseType: 'blob', signal, headers: { 'Cache-Control': 'no-store' },
  })).data,
  // Input and activation requests are never retried automatically.
  input: async (id, input) => { await apiClient.post(`${jobPath(id)}/input`, input); },
};

export default danlonActivationService;
